import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Menu } from 'lucide-react';
import Sidebar from './Sidebar';

export default function Layout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div className="flex h-screen bg-surface-900">
      <Sidebar
        open={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
        collapsed={collapsed}
        onToggleCollapse={() => setCollapsed(!collapsed)}
      />

      <div className="flex flex-1 flex-col overflow-hidden">
        {/* Top bar (mobile only) */}
        <header className="flex items-center gap-3 border-b border-surface-600 bg-surface-800 px-4 py-3 lg:hidden">
          <button
            onClick={() => setSidebarOpen(true)}
            className="rounded-lg p-1.5 text-slate-400 hover:bg-surface-700 hover:text-neon-cyan"
          >
            <Menu size={22} />
          </button>
          <h1 className="text-lg font-bold text-slate-100">Dr. Mali Admin</h1>
        </header>

        {/* Page content */}
        <main className="flex-1 overflow-y-auto bg-surface-900 p-4 lg:p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
